import { directionalityAwareAliases } from '#components/icon/directionality-aware-aliases.ts';
import { BASE_ICON_MAP } from './base-icon-map';

export type GDSIconToken = keyof typeof BASE_ICON_MAP;
export type GDSIconName = GDSIconToken | string;
export type GDSIcons = Record<GDSIconName, any>;
export type DirectionalityAwareAlias = keyof typeof directionalityAwareAliases;

// The syntax to retain autocomplete of GDSIconToken but also allow for path strings
// This is necessary because doing icon: GDSIconToken | string; removes autocomplete
// https://github.com/microsoft/TypeScript/issues/29729#issuecomment-460346421
type FilePath = string & { what?: any };
export type GDSIconSource = GDSIconToken | DirectionalityAwareAlias | FilePath;

export const getThemeIcons = (customIcons?: GDSIcons): GDSIcons => ({
  ...BASE_ICON_MAP,
  ...customIcons,
});
